import { MatSnackBarConfig } from '@angular/material/snack-bar';

export const snackbarDefaultConfig: MatSnackBarConfig = {
  duration: 5000,
  panelClass: 'opacity-80',
  verticalPosition: 'top',
  horizontalPosition: 'right'
}

export const snackbarDefaultIcon = {
  'success': 'task_alt',
  'info': 'info',
  'warning': 'warning',
  'error': 'error'
}

export const snackbarDefaultTextColor = {
  'success': 'text-green-400',
  'info': 'text-blue-400',
  'warning': 'text-yellow-400',
  'error': 'text-red-400'
}

export const snackbarDefaultBackgroundColor = {
  'success': 'bg-green-300',
  'info': 'bg-blue-100',
  'warning': 'bg-yellow-300',
  'error': 'bg-red-100'
}

export const snackbarDefaultProgressBarColor = {
  'success': '#85b15e',
  'info': '#4baaf5',
  'warning': '#fccc55',
  'error': '#f6675c'
}

export const snackbarDefaultActionButton = {
  color: 'text-white',
  label: 'Ok',
  raised: true,
}
